export default __webpack_public_path__ + "static/media/504.afeaf506.png";